import * as React from "react";
import { IDataCenter } from "../../vm";
import {
  sensorFileUpload,
  fileUpload,
  getADataCenter,
} from "../../services/datacenter/DatacenterService";
import { useHistory, useParams } from "react-router-dom";
import { Loading } from "../../services/Loading";
import {
  Stack,
  Text,
  Pivot,
  PivotItem,
  PrimaryButton,
} from "office-ui-fabric-react";
import NoDataPage from "../common/NoDataPage";
import DataCenterManagerMain from "../datacenter-manager/DataCenterManagerMain";
import ShiftManagerMain from "../shift-manager/ShiftManagerMain";
import { parseJwt } from "../../services/UtilService";
import InfraStructureMain from "../infrastructure/InfraStructureMain";
import EscalationMatrixMain from "../escalation-matrix/EscalationMatrixMain";
// import ConfigMain from "../config/ConfigMain";
import { ToastContext } from "../common/ToastProvider";
import { childrenGap } from "../common/Constants";
import ManageImportDialog from "./ManageImportDialog";
import InfraStructureAutomationMain from "../infrastructure-automation/InfraStructureAutomationMain";
import PMScheduleMain from "../pm-schedule/PMScheduleMain";

export interface DataCenterMainProps {}

const DataCenterMain: React.FC<DataCenterMainProps> = () => {
  const [state, setState] = React.useState({
    isLoading: false,
    isDataCenterFound: false,
    dataCenter: {
      name: "",
      location: "",
      buildings: [],
      floors: [],
      quadrants: [],
    },
    selectedKey: "infrastructure",
    // selectedKey: 'units-list',
    manualImportDialogOpen: false,
  } as {
    dataCenter: IDataCenter;
    isLoading: boolean;
    isDataCenterFound: boolean;
    selectedKey: string;
    manualImportDialogOpen: boolean;
  });

  const history = useHistory();
  const params: any = useParams();
  const { showToast } = React.useContext(ToastContext);

  React.useEffect(() => {
    const asyncFunc = async () => {
      let hash = window.location.hash;
      if (hash) {
        hash = hash.substr(1);
        setState({ ...state, selectedKey: hash });
      }
      await getDataCenter();
      //   await handleLocationHashChange();
      console.log("params", params);
      // window.addEventListener("hashchange", handleLocationHashChange, false);
    };
    asyncFunc();
  }, []);

  // React.useEffect(() => {
  //   let hash = window.location.hash;
  //   if (hash) {
  //     hash = hash.substr(1);
  //     setState({ ...state, selectedKey: hash });
  //   }
  // }, [window.location.hash]);

  const getDataCenter = async () => {
    setState({ ...state, isLoading: true });
    let res = await getADataCenter(params.dataCenterId);
    if (res && res.success) {
      setState({
        ...state,
        dataCenter: res.data,
        isLoading: false,
        isDataCenterFound: true,
      });
    } else {
      setState({ ...state, isLoading: false, isDataCenterFound: false });
      showToast(res?.message || "Error while getting Datacenter", "error");
    }
  };

  const _getTabId = (itemKey: string): string => {
    return `${itemKey}`;
  };

  const handleLocationHashChange = () => {
    let hash = window.location.hash;
    if (hash) {
      hash = hash.substr(1);
      let selectedKey = hash;
      setState({
        ...state,
        selectedKey: selectedKey,
      });
    }
  };

  const handleCallToRouter = (value: any) => {
    setState({
      ...state,
      selectedKey: value.props.itemKey,
    });
    history.push(window.location.pathname + "#" + value.props.itemKey);
  };

  const onSensorFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    let files = event.target.files;
    if (files) {
      let selectedFile = files[0];
      let data = {
        dataCenterId: params.dataCenterId,
      };
      setState({
        ...state,
        isLoading: true,
      });
      let res = await sensorFileUpload(selectedFile, data);
      if (res && res.success) {
        showToast("Imported Successfully", "success");
      } else {
        showToast(res.message || "An error occurred while importing", "error");
      }
      setState({
        ...state,
        isLoading: false,
      });
      let file: any = document.getElementById("sensorFile");
      if (file) {
        file["value"] = "";
      }
    }
  };

  const onFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    let files = event.target.files;
    if (files) {
      let selectedFile = files[0];
      let data = {
        dataCenterId: params.dataCenterId,
      };
      setState({
        ...state,
        isLoading: true,
      });
      let res = await fileUpload(selectedFile, data);
      if (res && res.success) {
        showToast("Imported Successfully", "success");
      } else {
        showToast(res.message || "An error occurred while importing", "error");
      }
      setState({
        ...state,
        isLoading: false,
      });
      let file: any = document.getElementById("file");
      if (file) {
        file["value"] = "";
      }
    }
  };

  const uploadFile = () => {
    let file = document.getElementById("file");
    if (file) file.click();
  };

  const uploadSensorFile = () => {
    let file = document.getElementById("sensorFile");
    if (file) file.click();
  };

  const tokenData = parseJwt();

  const handleDialogClose = () => {
    setState({
      ...state,
      manualImportDialogOpen: false,
    });
  };

  const handleLoading = () => {
    setState((prev) => ({
      ...prev,
      isLoading: !prev.isLoading,
    }));
  };

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      {state.isDataCenterFound ? (
        <React.Fragment>
          <Stack
            horizontal
            horizontalAlign="space-between"
            wrap
            tokens={childrenGap}
          >
            <Stack.Item>
              <Text className="datacenter-name-location">
                {state.dataCenter && state.dataCenter.name}{" "}
                {state.dataCenter && state.dataCenter.location && " - "}
                {state.dataCenter && state.dataCenter.location}
              </Text>
            </Stack.Item>
            <Stack.Item>
              <Stack horizontal wrap tokens={childrenGap}>
                {/* <Stack.Item>
                  <input
                    type="file"
                    style={{ display: "none" }}
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    onChange={onSensorFileChange}
                    id="sensorFile"
                  />
                  <PrimaryButton onClick={uploadSensorFile}>
                    Import Sensor
                  </PrimaryButton>
                </Stack.Item>
                <Stack.Item>
                  <input
                    type="file"
                    style={{ display: "none" }}
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    onChange={onFileChange}
                    id="file"
                  />
                  <PrimaryButton onClick={uploadFile}>Import</PrimaryButton>
                </Stack.Item> */}
                <Stack.Item>
                  <PrimaryButton
                    onClick={() =>
                      setState({ ...state, manualImportDialogOpen: true })
                    }
                  >
                    Manual Import
                  </PrimaryButton>
                </Stack.Item>
              </Stack>
            </Stack.Item>
          </Stack>

          <Stack className="pt-8">
            <Pivot
              onLinkClick={handleCallToRouter}
              defaultSelectedKey="infrastructure"
              getTabId={_getTabId}
              selectedKey={state.selectedKey}
            >
              <PivotItem
                itemKey="infrastructure"
                headerText="Infrastructure (Manual Reading)"
              >
                {state.dataCenter && state.dataCenter._id && (
                  // <UnitsPage dataCenter={state.dataCenter} />
                  <InfraStructureMain datacenter={state.dataCenter} />
                  // <React.Fragment>Infrastructure</React.Fragment>
                )}
              </PivotItem>
              <PivotItem
                itemKey="infrastructure-automation"
                headerText="Infrastructure (Automation)"
              >
                {state.dataCenter && state.dataCenter._id && (
                  // <UnitsPage dataCenter={state.dataCenter} />
                  <InfraStructureAutomationMain datacenter={state.dataCenter} />
                  // <React.Fragment>Infrastructure</React.Fragment>
                )}
              </PivotItem>
              {tokenData.isAdmin && (
                <PivotItem
                  itemKey="shift-manager"
                  headerText="Shift Manager/Operator"
                >
                  {state.dataCenter && state.dataCenter._id && (
                    // <ShiftManagerPage dataCenter={state.dataCenter} />
                    <ShiftManagerMain dataCenter={state.dataCenter} />
                  )}
                </PivotItem>
              )}
              {tokenData.isAdmin &&
                (tokenData.role === 0 || tokenData.role === 3) && (
                  <PivotItem
                    itemKey="datacenter-manager"
                    headerText="Datacenter Manager"
                  >
                    {state.dataCenter && state.dataCenter._id && (
                      // <UnitsPage dataCenter={state.dataCenter} />
                      <DataCenterManagerMain dataCenter={state.dataCenter} />
                    )}
                  </PivotItem>
                )}
              <PivotItem
                itemKey="escalation-matrix"
                headerText="Escalation Matrix"
              >
                {state.dataCenter && state.dataCenter._id && (
                  // <UnitsPage dataCenter={state.dataCenter} />
                  <EscalationMatrixMain dataCenter={state.dataCenter} />
                )}
              </PivotItem>
              {/* <PivotItem
                itemKey="preventive-maintenence-schedule"
                headerText="Preventive Maintenence Schedule"
              >
                {state.dataCenter && state.dataCenter._id && (
                  // <UnitsPage dataCenter={state.dataCenter} />
                  <PMScheduleMain dataCenter={state.dataCenter} />
                )}
              </PivotItem> */}
              {/* <PivotItem
                itemKey="config"
                headerText="Config"
              >
                {state.dataCenter && state.dataCenter._id && (
                  // <UnitsPage dataCenter={state.dataCenter} />
                  <ConfigMain/>
                )}
              </PivotItem> */}
            </Pivot>
          </Stack>
        </React.Fragment>
      ) : (
        <NoDataPage
          title="No Datacenter Found"
          subTitle="Datacenter either deleted or not created"
        />
      )}
      {state.manualImportDialogOpen && (
        <ManageImportDialog
          handleDialogClose={() => handleDialogClose()}
          datacenterId={params.dataCenterId}
          handleLoading={handleLoading}
        />
      )}
    </React.Fragment>
  );
};

export default DataCenterMain;
